import { useState } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useIsDeveloper } from "@/hooks/use-is-developer";
import type { CrmMasterDetail } from "@/lib/api/crm/masters";
import { DeleteMasterDialog } from "./DeleteMasterDialog";

/** Developer package only; renders nothing for anyone else. */
export function DeleteMasterButton({ master }: { master: CrmMasterDetail }) {
  const isDeveloper = useIsDeveloper();
  const [isOpen, setIsOpen] = useState(false);

  if (!isDeveloper) return null;

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="text-red-700 hover:bg-red-50 hover:text-red-800"
        onClick={() => setIsOpen(true)}
        data-testid="crm-delete-master"
      >
        <Trash2 className="mr-2 h-4 w-4" />
        Delete master record
      </Button>
      {isOpen && <DeleteMasterDialog master={master} onClose={() => setIsOpen(false)} />}
    </>
  );
}
